import { render, staticRenderFns } from "./SignupView.vue?vue&type=template&id=cb00cfca&"
import script from "./SignupView.vue?vue&type=script&lang=js&"
export * from "./SignupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports